export const departmentIcons = [
  {
    name: 'bee-icon',
    url: 'https://cdn.bringliesel.de/icons/departments/1-bee.svg',
  },
  {
    name: 'squirrel-icon',
    url: 'https://cdn.bringliesel.de/icons/departments/2-squirrel.svg',
  },
  {
    name: 'turtle-icon',
    url: 'https://cdn.bringliesel.de/icons/departments/3-turtle.svg',
  },
  {
    name: 'cat-icon',
    url: 'https://cdn.bringliesel.de/icons/departments/4-cat.svg',
  },
  {
    name: 'bird-icon',
    url: 'https://cdn.bringliesel.de/icons/departments/5-bird.svg',
  },
  {
    name: 'butterfly-icon',
    url: 'https://cdn.bringliesel.de/icons/departments/6-butterfly.svg',
  },
  {
    name: 'owl-icon',
    url: 'https://cdn.bringliesel.de/icons/departments/7-owl.svg',
  },
  {
    name: 'hen-icon',
    url: 'https://cdn.bringliesel.de/icons/departments/8-hen.svg',
  },
  {
    name: 'easter-bunny-icon',
    url: 'https://cdn.bringliesel.de/icons/departments/9-easter-bunny.svg',
  },
  {
    name: 'fox',
    url: 'https://cdn.bringliesel.de/icons/departments/10-fox.svg',
  },
  {
    name: 'mouse',
    url: 'https://cdn.bringliesel.de/icons/departments/11-mouse.svg',
  },
  {
    name: 'snail',
    url: 'https://cdn.bringliesel.de/icons/departments/12-snail.svg',
  },
  {
    name: 'sheep',
    url: 'https://cdn.bringliesel.de/icons/departments/13-sheep.svg',
  },
  {
    name: 'elephant',
    url: 'https://cdn.bringliesel.de/icons/departments/14-elephant.svg',
  },
  {
    name: 'giraffe',
    url: 'https://cdn.bringliesel.de/icons/departments/15-giraffe.svg',
  },
  {
    name: 'koala',
    url: 'https://cdn.bringliesel.de/icons/departments/16-koala.svg',
  },
  {
    name: 'whale',
    url: 'https://cdn.bringliesel.de/icons/departments/17-whale.svg',
  },
  {
    name: 'fish',
    url: 'https://cdn.bringliesel.de/icons/departments/18-fish.svg',
  },
  {
    name: 'dolphin',
    url: 'https://cdn.bringliesel.de/icons/departments/19-dolphin.svg',
  },
  {
    name: 'penguin',
    url: 'https://cdn.bringliesel.de/icons/departments/20-penguin.svg',
  },
  {
    name: 'walrus',
    url: 'https://cdn.bringliesel.de/icons/departments/21-walrus.svg',
  },
  {
    name: 'crab',
    url: 'https://cdn.bringliesel.de/icons/departments/22-crab.svg',
  },
  {
    name: 'cow',
    url: 'https://cdn.bringliesel.de/icons/departments/23-cow.svg',
  },
  {
    name: 'pig',
    url: 'https://cdn.bringliesel.de/icons/departments/24-pig.svg',
  },
  {
    name: 'dog',
    url: 'https://cdn.bringliesel.de/icons/departments/25-dog.svg',
  },
  {
    name: 'deer',
    url: 'https://cdn.bringliesel.de/icons/departments/26-deer.svg',
  },
];

export const b2bDepartmentIcon =
  'https://cdn.bringliesel.de/icons/departments/B2B_department.svg';
